import { render, staticRenderFns } from "./CombinedSnippetBlockEditor.vue?vue&type=template&id=5d4c91ad&scoped=true&"
import script from "./CombinedSnippetBlockEditor.vue?vue&type=script&lang=js&"
export * from "./CombinedSnippetBlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./CombinedSnippetBlockEditor.vue?vue&type=style&index=0&id=5d4c91ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c91ad",
  null
  
)

export default component.exports